import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ProductDecorator } from '../../../model/product/product.decorator';

@Component({
    selector: 'product-discount-label',
    templateUrl: './product-discount-label.component.html',
    styleUrl: './product-discount-label.component.scss',
    standalone: true,
    imports: [SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDiscountLabelComponent extends UiComponent {
    @Input()
    product!: ProductDecorator<IProductDataV3>;

    get discountPercentage(): number | undefined {
        if (this.product.orgPrice && this.product.price) {
            const discount = ((this.product.orgPrice - this.product.price) / this.product.orgPrice) * 100;
            return Math.floor(discount);
        }
        return undefined;
    }
}
